import React from "react";
import Page from "../components/Page";

const CodeOfEthics = () => (
  <Page title="Code of Ethics Us">this is the Code of Ethics</Page>
);

export default CodeOfEthics;
